import {
  useBreakpoint,
  Button,
  ButtonSize,
  ButtonStyles,
  Theme,
  NextgenImage,
  GenericLink,
  Breakpoints,
  ButtonWidth,
  LoaderType,
} from '@nextgen-web-framework/all';
import { useState } from 'react';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import type { HeroComponentProps } from './types/propsTypes';
import styles from './HeroComponent.module.scss';

const HeroComponent = (props: HeroComponentProps) => {
  const viewPortType = useBreakpoint();
  const isTablet = [Breakpoints.MD].includes(viewPortType as Breakpoints);
  const images = props?.images.find((item) => item?.viewport.includes(viewPortType));
  const { heroTitle, heroDescription, tagline, ctaButton } = props;
  const hasFooter = !!heroTitle || !!heroDescription || !!tagline || !!ctaButton?.text;
  const [imgLoading, setImgLoading] = useState(true);

  return (
    <div className={styles['hero-container']} data-testid={'hero-container-test-id'}>
      <div className={`${hasFooter ? styles['img-container'] : styles['img-without-footer']}`}>
        <NextgenImage
          src={images?.image.url ?? ''}
          className={imgLoading ? styles['hero-banner-image-hidden'] : styles['hero-banner-image']}
          onLoad={() => setImgLoading(false)}
          alt={images?.alt_text ?? ''}
          loaderType={LoaderType.CONTENTSTACK}
          imageWidths={{
            small: 735,
            medium: 960,
            large: 1440,
            xlarge: 1440,
          }}
        />
        {imgLoading && <SkeletonLoader height={562} borderRadius={12} />}
      </div>
      {hasFooter ? (
        <div className={styles['hero-footer-container']}>
          <div className={styles['hero-content-container']}>
            {heroTitle && heroTitle !== '' && <h2 className={styles['hero-title']}>{heroTitle}</h2>}
            {heroDescription && heroDescription !== '' && <h6 className={styles['hero-content']}>{heroDescription}</h6>}
            {tagline && tagline !== '' && <div className={styles['hero-source-and-time']}>{tagline}</div>}
          </div>
          {ctaButton && ctaButton?.text !== '' && (
            <div className={styles['hero-button-container']}>
              <GenericLink
                href={ctaButton.url ?? ''}
                target={ctaButton.target}
                className={styles['hero-button-link-wrapper']}
              >
                <Button
                  title={ctaButton?.text}
                  buttonStyle={ButtonStyles.SOLID}
                  theme={Theme.PURPLE}
                  size={ButtonSize.MEDIUM}
                  data-testid="hero-banner-btn"
                  buttonWidth={isTablet ? ButtonWidth.FULL_WIDTH : undefined}
                />
              </GenericLink>
            </div>
          )}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default HeroComponent;
export type { HeroComponentProps };
